export default {
  password: {
    required: true,
    min: 8,
    regex: /^.*\D+.*$/
  }
}
